export const HELP_URL = '/help/hub?ref=header';
export const HELP_URL_LEGACY = '/hz/vendor/members/support/hub';
export const SIGN_OUT_URL = '/sign-out';
